"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneInputFormItem = void 0;
var react_1 = __importDefault(require("react"));
var react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
var formik_1 = require("formik");
var formik_antd_1 = require("formik-antd");
var styled_components_1 = __importDefault(require("styled-components"));
require("react-phone-input-2/lib/style.css");
var StyledPhone = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    .react-tel-input .form-control {\n      width: 100%;\n      height: 32px;\n      border-radius: 2px;\n    }\n  }\n"], ["\n  &&& {\n    .react-tel-input .form-control {\n      width: 100%;\n      height: 32px;\n      border-radius: 2px;\n    }\n  }\n"])));
var PhoneInput = function (_a) {
    var name = _a.name, validate = _a.validate, _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.className, className = _c === void 0 ? "" : _c, phoneInputProps = __rest(_a, ["name", "validate", "style", "className"]);
    var _d = formik_1.useField({
        name: name,
        validate: validate,
    }), value = _d[0].value, _e = _d[2], setValue = _e.setValue, setTouched = _e.setTouched;
    return (react_1.default.createElement(StyledPhone, { className: className, style: style },
        react_1.default.createElement(react_phone_input_2_1.default, __assign({}, phoneInputProps, { value: value, onChange: function (phone) {
                setValue(phone ? "+" + phone : "");
                setTouched(true);
            } }))));
};
var PhoneInputFormItem = function (_a) {
    var field = _a.field, phoneInput = _a.phoneInput;
    return (react_1.default.createElement(formik_antd_1.FormItem, __assign({}, field),
        react_1.default.createElement(PhoneInput, __assign({}, phoneInput))));
};
exports.PhoneInputFormItem = PhoneInputFormItem;
exports.default = PhoneInput;
var templateObject_1;
